<template>
    <div class="task-list" :style="{ '--count': count }">
        <div class="task-item" v-for="task in taskList" :key="task.id">
            <div class="task-item_title">
                <div class="title-text ellipsis-multiple">
                    <i class="mode">{{ task.task_mode === 1 ? "招募" : "竞单" }}</i>
                    {{ task.task_name }}
                </div>
            </div>

            <div class="task-item_status">
                <div class="status-top">
                    <span> {{ statusMap[task.task_status] }} </span>
                    ·
                    {{ task.task_type_info?.name }}
                </div>

                <div class="status-budget">{{ task.task_budget }}金币</div>
            </div>

            <div class="task-item_desc" :class="{ 'show-time': showTime }">
                <div class="desc-text ellipsis-multiple">{{ task.task_description }}</div>
            </div>

            <div class="task-item_time" v-if="showTime">发布时间：{{ task.create_time }}</div>

            <div class="task-item_btn">
                <slot :task="task"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            statusMap: {
                1: "报名中",
                2: "进行中",
                3: "圆满完成",
            },
        };
    },

    props: {
        taskList: {
            type: Array,
            default: () => [],
        },

        showTime: {
            type: Boolean,
            default: false,
        },

        count: {
            type: Number,
            default: 4,
        },
    },
};
</script>

<style lang="scss" scoped>
.task-list {
    --gap: 20px;
    // --count: 4;
    --avaliable-width: calc(100% - (var(--count) - 1) * var(--gap));
    --auto-width: calc(var(--avaliable-width) / var(--count));
    display: flex;
    flex-wrap: wrap;
    gap: var(--gap);

    .task-item {
        width: var(--auto-width);
        min-width: 288px;
        aspect-ratio: 380 / 265;
        border: 1px solid #e6e6e6;
        box-sizing: border-box;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border-radius: 4px;

        &_title {
            // flex-shrink: 0;
            font-weight: 600;
            font-size: 16px;
            color: #333333;
            height: 25%;

            i.mode {
                font-style: normal;
                padding: 2px 6px;
                background: #f6ffed;
                border-radius: 2px;
                border: 1px solid #01a04b;
                color: #6bc45c;
                font-size: 12px;
                display: inline-block;
            }
        }

        &_status {
            .status-top {
                font-weight: 500;
                font-size: 12px;
                color: #666666;
            }

            .status-budget {
                margin-top: 10px;
                font-weight: 500;
                font-size: 16px;
                color: #ff6900;
            }
        }

        &_desc {
            font-weight: 400;
            font-size: 12px;
            color: #666666;
            height: 20%;

            &.show-time {
                height: auto;
            }
        }

        &_time {
            font-weight: 500;
            font-size: 12px;
            color: #999999;
        }

        &_btn {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;

            .btn {
                height: 32px;
                background: linear-gradient(270deg, #291ce7 0%, #594fed 100%);
                border-radius: 16px;
                font-weight: 500;
                font-size: 16px;
                color: #ffffff;
                cursor: pointer;

                &.success {
                    background: #3fca13;
                }

                &.miss {
                    background: #d9d9d9;
                    border-radius: 4px;
                    color: #999999;
                }
            }
        }
    }
}
</style>
